module.exports = __webpack_public_path__ + "img/icon-round-money.410ddbd7.svg";